import embeddingService from "services/embeddingService";

const setContextRoute = (
    conversationId: string,
    evaluationId: string,
    isAdmin = false,
    assignmentPanel?: boolean
) => {
    const destination = isAdmin
        ? `#/engage/admin/interactions/${conversationId}/qualitySummary/?evaluationId=${evaluationId}${
              assignmentPanel ? `&assignmentPanel=${assignmentPanel}` : ""
          }`
        : `#/engage/agent/interactions/${conversationId}/?evaluationId=${evaluationId}`;
    embeddingService.requestNavigation(destination);
};

export default setContextRoute;
